import Icon from '@/components/Icon/Icon';

const DeviceDefaultNameIcon = (props) => {
    return (
        <Icon width='48' height='48' viewBox='0 0 48 48' fill='none' {...props}>
            <path
                d='M21 6C25.1421 6 28.5 9.35786 28.5 13.5V34.5C28.5 38.6421 25.1421 42 21 42H18.75C17.8922 42 17.0713 41.8397 16.3164 41.5479C15.9626 41.4108 15.75 41.0581 15.75 40.6787V7.32129C15.75 6.94185 15.9626 6.58918 16.3164 6.45215C17.0713 6.16034 17.8922 6 18.75 6H21ZM14.625 39.4443C13.256 38.3687 12.375 36.7002 12.375 34.8242V13.375C12.375 11.4988 13.2558 9.8295 14.625 8.75391V39.4443Z'
                fill='#393E44'
            />
            <path fillRule='evenodd' clipRule='evenodd' d='M14.625 30.75H12.375V29.25H14.625V30.75Z' fill='#00D1D2' />
            <path
                d='M30.5996 10.4341C30.5996 10.1252 30.85 9.87488 31.1588 9.87488H34.6904C34.9992 9.87488 35.2496 10.1252 35.2496 10.4341V36.6328L34.902 41.1337C34.8795 41.425 34.6366 41.6499 34.3444 41.6499H31.5048C31.2127 41.6499 30.9697 41.425 30.9472 41.1337L30.5996 36.6328V10.4341Z'
                fill='#393E44'
            />
            <rect x='31.375' y='18.3999' width='3.1' height='4.65' rx='1.55' fill='#00D1D2' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M32.9254 19.175C33.3534 19.175 33.7004 19.522 33.7004 19.95V21.5C33.7004 21.9281 33.3534 22.275 32.9254 22.275C32.4974 22.275 32.1504 21.9281 32.1504 21.5V19.95C32.1504 19.522 32.4974 19.175 32.9254 19.175Z'
                fill='#FFFDFB'
            />
        </Icon>
    );
};

export default DeviceDefaultNameIcon;
